export default {
  items: [
    {
      name: 'หน้าแรก',
      url: '/admin/dashboard',
      icon: 'icon-speedometer'
    },
    {
      name: 'รายงาน',
      url: '/admin/report',
      icon: 'icon-shield',
      children: [{
          name: 'รายงาน.....',
          url: '/admin/report/rep1',
          icon: ''
        },
      ]
    },
  ]
}
